"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formDataToValue = formDataToValue;
exports.queryDataToValue = queryDataToValue;
exports.stringToBool = stringToBool;
function queryDataToValue(data, typing) {
  if ((typing === null || typing === void 0 ? void 0 : typing.name) === "tuple") {
    let values = Array.isArray(data) ? data : data.split(/\n/);
    let converted = [];
    let i = 0;
    for (let val of values) {
      converted.push(queryDataToValue(val, typing.components[i]));
      ++i;
    }
    return converted;
  }
  if (typing !== null && typing !== void 0 && typing.array) {
    let values = Array.isArray(data) ? data : data.split(/\n/);
    if ((typing === null || typing === void 0 ? void 0 : typing.name) === "bool") {
      return values.map(stringToBool);
    } else {
      return values;
    }
  }
  if (Array.isArray(data)) {
    data = data[0];
  }
  if ((typing === null || typing === void 0 ? void 0 : typing.name) === "bool") {
    return stringToBool(data);
  }
  return data;
}
function formDataToValue(data, typing) {
  if (Array.isArray(data)) {
    let array = data.map(it => {
      let values = Object.values(it);
      if (values.length === 1) {
        return values[0];
      }
      if (values.length === 0) {
        return "";
      }
      console.warn("formData array object had more than one value: ", values);
      return values;
    });
    if ((typing === null || typing === void 0 ? void 0 : typing.name) === "bool") {
      return array.map(stringToBool);
    }
    return array;
  }
  return data;
}
function stringToBool(data) {
  switch (data.toLowerCase()) {
    case "0":
    case "false":
    case "no":
      return false;
    default:
      return true;
  }
}
//# sourceMappingURL=data.js.map